import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Row,
  Container,
  Col,
  Badge,
  Button,
  Modal,
} from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { Layers, Users, Mail, MessageSquare } from "react-feather";
import PopulationCard from "./PopulationCard";
import EnrollmentStatusCard from "./enrollment_statuses/EnrollmentStatusCard";
import SearchStudentCard from "./SearchStudentCard";
import ClassDistribution from "./ClassDistribution";

const StudentsManagementPage = () => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <Helmet title="Student Management" />
      <Container fluid className="p-0">
        <div className="d-flex mb-3 flex-row justify-content-between">
          <h1 className="h3 ">Student Management</h1>
          <Button
            onClick={() => navigate("enroll-new-student")}
            variant="outline-primary"
          >
            New Student
          </Button>
        </div>
        <Row className="equal-height-col">
          <Col md={4}>
            <PopulationCard />
          </Col>
          <Col md={4}>
            <EnrollmentStatusCard />
          </Col>
          <Col md={4}>
            <SearchStudentCard />
          </Col>
        </Row>
        <Row>
          <ClassDistribution />
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default StudentsManagementPage;
